import { useEffect, FC, PropsWithChildren } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { UnregisterCallback } from 'history';

type ScrollToTopProps = PropsWithChildren<RouteComponentProps>;

const ScrollToTop: FC<ScrollToTopProps> = ({ history, children }: ScrollToTopProps) => {
  useEffect(() => {
    const unlisten: UnregisterCallback = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return <>{children}</>;
};

export default withRouter(ScrollToTop);
